import { render } from "./ThresholdManagementModal.vue?vue&type=template&id=a1d9694a&scoped=true&ts=true&lang=pug"
import script from "./ThresholdManagementModal.vue?vue&type=script&lang=ts"
export * from "./ThresholdManagementModal.vue?vue&type=script&lang=ts"

import "./ThresholdManagementModal.vue?vue&type=style&index=0&id=a1d9694a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d9694a"]])

export default __exports__